/*eslint max-lines-per-function: ["error", 100]*/
import React, { useCallback, useState } from 'react';
import { Card } from 'react-bootstrap';

import type {
  GridGetterFunction,
  GridCountFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { PaymentCollectionsSearch } from '../../components/PaymentCollection/PaymentCollectionsSearch';
import { CsvImportSection } from '../../components/Common/CsvImportSection';

export const PaymentCollectionsView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const [refreshKey, setRefreshKey] = useState(0);

  const getData: GridGetterFunction = useCallback(
    (
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    ) =>
      spd.paymentCollections.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ),
    [spd.paymentCollections],
  );

  const getCount: GridCountFunction = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.paymentCollections.getAllCount(filterText, filterColumns),
    [spd.paymentCollections],
  );

  return (
    <Card>
      <Card.Header>Zbiory wpłat</Card.Header>
      <Card.Body>
        <PaymentCollectionsSearch
          getData={getData}
          getCount={getCount}
          showFilter={true}
          withFilterInColumns={true}
          onRowClick={(id: string) => nav.paymentCollectionPayments(id)}
          refresh={refreshKey > 0}
        />
        <CsvImportSection
          title="Importuj wpłaty z CSV (mBank)"
          importFunction={(file: File) =>
            spd.invoicePayments.importCsv(file, file.name)
          }
          onImported={() => setRefreshKey(k => k + 1)}
        />
      </Card.Body>
    </Card>
  );
};
